const { AllMappingDimensions } = require('./allDimensionArrays');

module.exports = AllMappingDimensions;
